import * as React from 'react'
import {
  commonProps,
  CommonProps,
  flexItemProps,
  FlexItemProps,
  compose
} from '@bestyled/system'
import styled from 'styled-components'
import { ViewBase } from './ViewBase'

export interface LayoutViewProps extends CommonProps, FlexItemProps {
  onLayout: (e: any) => void
  ref?: any
}

/** The View component is a generic container that has margin, padding, width, height and position */
const LayoutViewStyled = styled(ViewBase<LayoutViewProps>('LayoutView'))`
  display: flex;
  width: 100%;
  height: 100%;
  ${compose(flexItemProps, commonProps)}
` as React.FC<React.PropsWithChildren<LayoutViewProps>>

export const LayoutView: React.FC<LayoutViewProps> = (props) => {
  const calcHeight = React.useCallback(
    (node: HTMLDivElement) => {
      if (node) {
        const layout = {
          x: node.offsetLeft,
          y: node.offsetTop,
          height: node.offsetHeight,
          width: node.offsetWidth
        }
        props.onLayout({ nativeEvent: { layout } })
      }
    },
    [props.onLayout]
  )

  return <LayoutViewStyled ref={calcHeight} {...props} />
}
